"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "setImageSmoothing", {
  enumerable: true,
  get: function get() {
    return _setImageSmoothing["default"];
  }
});

var _setImageSmoothing = _interopRequireDefault(require("./setImageSmoothing"));